// export const BASE_URL = 'http://localhost:3001/v1';
// export const HOST_URL = 'http://localhost:3000';
export const BASE_URL = 'https://back.teaswap.art/v1';
export const HOST_URL = 'https://www.teaswap.art';
